import { Component, Input, OnDestroy, ViewEncapsulation, HostBinding } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../animations/page-transitions';
import { AllQualityIssue } from '../../../claim/models/all-quality-issue';
import { ClaimStatus, CLOSED_STATUS_LIST, PENDING_STATUS_LIST } from '../../../claim/models/quality-issue';
import { AllQualityIssueService } from '../../../claim/services/all-quality-issue.service';
import { QualityIssueService } from '../../../claim/services/quality-issue.service';
import { NumberPipe } from '../../pipes/number.pipe';
import { LoadingSpinnerComponent } from '../utils/loading-spinner.component';

@Component({
	selector: 'copo-request-claim-widget',
	templateUrl: './claim-request-widget.component.html',
	styleUrl: './claim-request-widget.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		TranslateModule,

		MatButtonModule,
		RouterLink,
		MatIconModule,
		LoadingSpinnerComponent,
		NumberPipe
	]
})
export class ClaimRequestWidgetComponent implements OnDestroy {
	@HostBinding('class.services-box') box = true;
	@Input() headerLabel!: string;
	@Input() btnLabel!: string;
	@Input() btnRouterLink!: string;
	draftCount = 0;
	pendingDraftCount = 0;
	pendingCount = 0;
	issuesSubscription: Subscription;
	isLoading = true;

	constructor(
		private readonly allQualityIssueService: AllQualityIssueService,
		private readonly qualityIssueService: QualityIssueService
	) {
		this.issuesSubscription = forkJoin([
			this.qualityIssueService.getIssuesCount(
				this.qualityIssueService.getAllIssuesbyPendingStatusFilter(),
			),
			this.allQualityIssueService.getQualityIssuesCount(
				this.allQualityIssueService.getAllIssuesbyPendingNotPushedStatusFilter(),
			),
			this.allQualityIssueService.getQualityIssuesCount(
				this.allQualityIssueService.getAllIssuesbyDraftStatusFilter(),
			),
		]).subscribe({
			next: ([{ count: pendingCount }, { count: notPushedCount }, { count: draftCount }]) => {
				this.pendingCount = pendingCount + notPushedCount;
				this.draftCount = draftCount;
				this.isLoading = false;
			},
			error: (err: unknown) => {
				console.error('unable to retrieve quality issue counts', err);
				this.isLoading = false;
			}
		});
	}

	ngOnDestroy() {
		this.issuesSubscription.unsubscribe();
	}

	newClaim() {
		this.allQualityIssueService.claim = new AllQualityIssue();
	}

	viewDetailsState(pending: boolean) {
		const filter: (
			{
				id: string;
				values: {
					apiName: string;
					selected: boolean;
					value: string;
				}[][];
			}
		)[] = [
			{
				id: 'status',
				values: [
					[
						ClaimStatus.DRAFT,
						ClaimStatus.PENDING,
						ClaimStatus.CREATED,
						ClaimStatus.CANCELLED,
						ClaimStatus.PAID,
						ClaimStatus.REFUSED,
						ClaimStatus.REGWARNING
					].map(status => ({
						apiName: 'status',
						selected: (pending ? PENDING_STATUS_LIST : CLOSED_STATUS_LIST).includes(status),
						value: status
					}))
				]
			}
		];

		return {
			filter
		};
	}
}
